jQuery(document).on("swup:pageView", function () {
  $ = jQuery;

  if ($("main.global-template").length) {
    var isMobile = window.matchMedia("only screen and (max-width: 949px)").matches;

    /*****************************************************************
      Testimonials
    ******************************************************************/
    var quoteSlider = $(".global-testimonials .owl-carousel"),
      autoplayTimeoutSpeed = 8000;

    quoteSlider.owlCarousel({
      autoplay: true,
      autoplayTimeout: autoplayTimeoutSpeed,
      loop: false,
      nav: true,
      navContainer: ".slide-item-nav",
      navText: ["", ""],
      items: 1,
      margin: 0,
      slideBy: 1,
      rewind: true,
      rewindNav: true,
      rewindSpeed: 0,
      dots: false,
      autoHeight: false,
      lazyLoad: true,
      checkVisibility: false,
      mouseDrag: false,
      pullDrag: false,
      onInitialized: function (e) {
        var totalCount = $(quoteSlider).parents(".container").find(".slide-num-contain .nums-total");
        var currentCount = $(quoteSlider).parents(".container").find(".slide-num-contain .nums-count");
        totalCount.text("0" + e.item.count);
        currentCount.text("0" + (e.item.index + 1));

        if (e.item.count == 1) {
          console.log("only one");
          this.options.loop = false;
          this.options.nav = false;
          this.options.mouseDrag = false;
          $(".global-testimonials").addClass("solo-slide");
        } else {
          console.log("multiple");
          this.options.loop = true;
          this.options.nav = true;
          this.options.mouseDrag = true;
        }

        if (e.item.index === 0) {
          $(".slide-progress .progress-bar")
            .eq(e.item.index)
            .children(".progress")
            .css({
              width: "100%",
              transition: autoplayTimeoutSpeed - 250 + "ms",
            });
        }
      },
      onTranslate: function (e) {
        $(".slide-progress .progress-bar").each(function (index, el) {
          if (index < e.item.index) {
            $(el).children(".progress").css({
              width: "100%",
              transition: "none",
            });
          } else {
            $(el).children(".progress").css({
              width: "0%",
              transition: "none",
            });
          }
        });
      },
      onTranslated: function (e) {
        $(".slide-progress .progress-bar").each(function (index, el) {
          if (index < e.item.index) {
            $(el).children(".progress").css({
              width: "100%",
              transition: "none",
            });
          }

          if (index === e.item.index) {
            $(el)
              .children(".progress")
              .css({
                width: "100%",
                transition: autoplayTimeoutSpeed - 250 + "ms",
              });
          }

          if (index > e.item.index) {
            $(el).children(".progress").css({
              width: "0%",
              transition: "none",
            });
          }
        });
      },
    });

    quoteSlider.on("changed.owl.carousel", function (e) {
      var currentCount = $(quoteSlider).parents(".container").find(".slide-num-contain .nums-count");
      currentCount.text("0" + (e.item.index + 1));
      quoteSlider.trigger("stop.owl.autoplay");
      quoteSlider.trigger("play.owl.autoplay", [autoplayTimeoutSpeed, 250]);

      var bgImages = $(".global-testimonials .background-images"),
        bgImagesInner = $(".global-testimonials .background-images .bg-contain");
      bgImages.children().each(function (index, el) {
        bgImagesInner.removeClass("active");
        bgImagesInner.eq(e.item.index).addClass("active");
      });
    });

    $(window).on("resize", function () {
      $(".global-testimonials .owl-carousel .owl-stage-outer").width(innerWidth);
    });

    // Stop Carousel on Modal popup
    $(".testimonials-carousel .play-btn").click(function () {
      quoteSlider.trigger("stop.owl.autoplay");
    });

    // Play Carousel on CLose of modal
    $(".modal .close-modal").click(function () {
      quoteSlider.trigger("play.owl.autoplay", [autoplayTimeoutSpeed, 250]);
    });

    /*****************************************************************
     * Cursor Manipulation
     *****************************************************************/
    var cursor = $(".cursor");
    $(window).mousemove(function (e) {
      cursor.css({
        top: e.clientY - cursor.height() / 2,
        left: e.clientX - cursor.width() / 2,
      });
    });

    $(".global-testimonials")
      .mouseleave(function () {
        cursor.css({
          opacity: "0",
        });
      })
      .mouseenter(function () {
        cursor.css({
          opacity: "1",
        });
      });

    $(".global-testimonials .owl-prev")
      .mouseenter(function () {
        cursor.css({
          transform: "scale(-1)",
        });
      })
      .mouseleave(function () {
        cursor.css({
          transform: "scale(1)",
        });
      });

    $(".global-testimonials .play-btn")
      .mouseenter(function () {
        cursor.css({
          opacity: "0",
        });
      })
      .mouseleave(function () {
        cursor.css({
          opacity: "1",
        });
      });
  }
});
